module.exports = __webpack_public_path__ + "img/loading.a20585dd.gif";